package com.ai.mitra

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.CanvasBasedWindow
import com.ai.mitra.di.initKoin
import org.jetbrains.skiko.wasm.onWasmReady
import org.koin.compose.koinInject

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    initKoin()
    onWasmReady {
        CanvasBasedWindow(title = "MITRA - My Intelligent Talkative Responsive Assistant", canvasElementId = "ComposeTarget") {
            App(koinInject())
        }
    }
}